/**
 * @file 文件检测
 * @author wangzhuang
 * */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {fetchVdcReport} from '../../actions/fileCheckAction';

import './index.less';

class FileCheck extends Component {
    static propTypes = {
        match: PropTypes.object,
        vdcReport: PropTypes.object,
        fetchVdcReport: PropTypes.func
    };

    constructor(props, context) {
        super(props, context);
        this.state = {};
        this.timer = null;
        this.timerNum = 0;
        this.timerCount = 24; // 轮询两分钟停止
    }

    componentDidMount() {
        let params = this.props.match.params;
        if (this.isPC()) {
            location.href = `/vdc/fileCheck?type=${params.type}&key=${params.key}`;
            return;
        }

        this.vdcReportFn();
        this.timer = setInterval(() => {
            this.timerNum++;
            this.vdcReportFn();
        }, 5000);
    }

    vdcReportFn() {
        if (this.timerNum >= this.timerCount) {
            clearInterval(this.timer);
        }
        let params = this.props.match.params;
        let json = {};
        if (params.type === 'report') {
            json.resource = params.key;
        } else {
            json['task_id'] = params.key;
        }
        this.props.fetchVdcReport(json, params.type).then(data => {
            let obj = data.data;
            if (params.type === 'report') {
                clearInterval(this.timer);
            }
            if (obj && obj.data) {
                if (obj.data.is_auth === 'bot') {
                    clearInterval(this.timer);
                }
                if (obj.data.scans && (obj.data.scans.status === 'merged' || obj.data.scans.status === 'error')) {
                    clearInterval(this.timer);
                }
            }
        });
    }

    mainLevelFn = val => {
        let str = 'tag_weizhi';
        switch (val) {
            case 100:
            case 110:
                str = 'tag_anquan';
                break;
            case 150:
            case 160:
                str = 'tag_weizhi';
                break;
            case 170:
            case 180:
                str = 'tag_keyi';
                break;
            case 190:
            case 200:
                str = 'tag_weixian';
                break;
            default:
                return '';
        }
        return <img
            src={require(`../../asset/image/product/${str}.svg`)}
            alt=""
        />;
    };

    levelFn = val => {
        let str = '';
        let htmlVal = '';
        switch (parseInt(val, 10)) {
            case 100:
            case 110:
                str = 'anquan';
                htmlVal = '安全';
                break;
            case 150:
            case 160:
            case 170:
            case 180:
                str = 'wufajiance';
                htmlVal = '无法检测';
                break;
            case 190:
            case 200:
                str = 'weixian';
                htmlVal = '危险';
                break;
            default:
                return '';
        }
        return <div
            style={{backgroundImage: `url(${require(`../../asset/image/product/icon_${str}.svg`)})`}}>
            {htmlVal}
        </div>;
    };

    fileTypeFn = type => {
        let str = 'qita';
        let fileType = /sys|dll|exe/.exec(type);
        if (fileType) {
            str = fileType[0];
        }

        return <img
            className={'mod1-top-img'}
            src={
                require(`../../asset/image/product/icon_file_${str}.svg`)
            }
            alt=""
        />;
    };

    render() {
        const {vdcReport, match} = this.props;
        let bot = false;
        let fileInfo = null;
        let scans = {};
        if (vdcReport.data) {
            if (vdcReport.data.meta) {
                fileInfo = match.params.type === 'report' ? vdcReport.data.meta : vdcReport.data.meta.file_info;
            }

            if (vdcReport.data.scans) {
                scans = vdcReport.data.scans;
                if (scans.status === 'error' && match.params.type !== 'report') {
                    bot = true;
                }
            }

            if (vdcReport.data.is_auth === 'bot') {
                bot = true;
            }
        }
        if (this.timerNum >= this.timerCount && this.isEmptyobj(vdcReport.data)) {
            bot = true;
        }
        return (
            <div className={'FileCheck'}>
                <div className={'fc-title'}>
                    文件检测
                </div>
                {bot
                    ? <div className={'fc-bot'}>
                        <img src={require('../../asset/image/product/pic_normalerror.svg')} alt=""/>
                        <div className={'fc-bot-text'}>检测结果异常，请重新检测。</div>
                    </div>
                    : <div>
                        {vdcReport.data && fileInfo
                            ? <div className={'fc-mod'}>
                                <div className={'mod1-top'}>
                                    <div className={'mod1-top-left'}>
                                        <span className={'mod1-top-name'}>该文件的检测结果为</span>
                                        {
                                            this.mainLevelFn(vdcReport.data.main_level)
                                        }
                                    </div>
                                    {this.fileTypeFn(fileInfo.type)}
                                </div>
                                <div className={'mod2-box'}>
                                    {
                                        fileInfo.name
                                            ? <div className={'mod-item'}>
                                                <div>文件名称</div>
                                                <div>{fileInfo.name}</div>
                                            </div>
                                            : null
                                    }

                                    {fileInfo.size
                                        ? <div className={'mod-item'}>
                                            <div>文件名大小</div>
                                            <div>{fileInfo.size}</div>
                                        </div>
                                        : null

                                    }
                                    {fileInfo.type
                                        ? <div className={'mod-item'}>
                                            <div>文件类型</div>
                                            <div>{fileInfo.type}</div>
                                        </div>
                                        : null
                                    }
                                    {fileInfo.md5
                                        ? <div className={'mod-item'}>
                                            <div>MD5</div>
                                            <div>{fileInfo.md5}</div>
                                        </div>
                                        : null
                                    }
                                    {vdcReport.data.scan_date
                                        ? <div className={'mod-item'}>
                                            <div>检测时间</div>
                                            <div>{vdcReport.data.scan_date}</div>
                                        </div>
                                        : null
                                    }
                                </div>
                            </div>
                            : <div className={'fc-mod'}>
                                <div className={'mod1-top'}>
                                    <div className={'mod1-top-left'}>
                                        <span className={'mod1-top-name'}>该文件的检测结果为</span>
                                        <img
                                            className={'vdc-loading'}
                                            src={require('../../asset/image/product/icon_spinner_large.svg')}
                                            alt=""
                                        />
                                    </div>
                                    <img
                                        className={'mod1-top-img'}
                                        src={require('../../asset/image/product/icon_file_loading.svg')}
                                        alt=""
                                    />
                                </div>
                                <div className={'mod2-box'}>
                                    <div className={'mod-item'}>
                                        <div>文件名称</div>
                                        <div>...</div>
                                    </div>
                                    <div className={'mod-item'}>
                                        <div>文件名大小</div>
                                        <div>...</div>
                                    </div>
                                    <div className={'mod-item'}>
                                        <div>文件类型</div>
                                        <div>...</div>
                                    </div>
                                    <div className={'mod-item'}>
                                        <div>MD5</div>
                                        <div>...</div>
                                    </div>
                                    <div className={'mod-item'}>
                                        <div>检测时间</div>
                                        <div>...</div>
                                    </div>
                                </div>
                            </div>
                        }

                        {vdcReport.data && vdcReport.data.scans
                            ? <div className={'fc-mod'}>
                                <div>
                                    <div className={'mod1-top'}>
                                        多源检测结果
                                    </div>
                                    <div className={'mod2-box'}>
                                        {
                                            Object.keys(scans).map((item, index) => {
                                                let obj = '';
                                                if (typeof scans[item] !== 'string') {
                                                    obj = <div className={'mod2-con'} key={index}>
                                                        {scans[item].level
                                                            ? <div className={'mod2-res'}>
                                                                <div className={''}>{item}</div>
                                                                {this.levelFn(scans[item].level)}
                                                            </div>
                                                            : null
                                                        }

                                                        {scans[item].result
                                                            ? <div className={'mod-item'}>
                                                                <div>病毒名称</div>
                                                                <div>{scans[item].result}</div>
                                                            </div>
                                                            : null
                                                        }

                                                        {scans[item].engine_version
                                                            ? <div className={'mod-item'}>
                                                                <div>引擎版本</div>
                                                                <div>{scans[item].engine_version}</div>
                                                            </div>
                                                            : null
                                                        }

                                                        {scans[item].library_version
                                                            ? <div className={'mod-item'}>
                                                                <div>病毒库版本</div>
                                                                <div>{scans[item].library_version}</div>
                                                            </div>
                                                            : null
                                                        }
                                                    </div>;
                                                }
                                                return obj;
                                            })
                                        }
                                    </div>

                                </div>
                            </div>
                            : <div className={'fc-mod'}>
                                <div style={{paddingBottom: '1.6rem'}}>
                                    <div className={'mod1-top'}>
                                        多源检测结果
                                    </div>
                                    <img
                                        className={'vdc-loading mod2-loading'}
                                        src={require('../../asset/image/product/icon_spinner_large.svg')}
                                        alt=""
                                    />
                                </div>
                            </div>
                        }
                    </div>

                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        vdcReport: state.vdcReport
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchVdcReport: (obj, type) => fetchVdcReport(dispatch, obj, type)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(FileCheck);



// WEBPACK FOOTER //
// ./src/containers/fileCheck/index.js